/* eslint-disable react/react-in-jsx-scope */
import Text from '../../shared/textStyleDefault/texto'

const CasosExito = (): any => {
  return (
    <div className='flex w-screen max-w-[1080px] mt-[56px] md:mt-[94px] mb-3 px-[8px]'>
        <Text as='h5' className='w-[840px] text-left'>Las operaciones digitales son la columna vertebral de una empresa moderna, y nuestro servicio de Soporte de Operaciones está diseñado para impulsar tu rendimiento a nuevos niveles. </Text>
    </div>
  )
}
export default CasosExito
